<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {
    
  },
  mounted() {
    // this.$nextTick(function() {
    //   window.addEventListener('resize', function () {
    //     let __width = document.documentElement.clientWidth
    //     let width =  __width > 1920 ? 1920 : __width
    //     document.documentElement.style.fontSize = `${width / 10}px` // 按照设计图
    //   })
    //   document.documentElement.style.fontSize = `${this.getWindowSize() / 10}px` // 按照设计图
    // });
  },
  methods: {
    // 获取屏幕当前的大小
    // getWindowSize() {
    //   const __width = document.documentElement.clientWidth
    //   return __width > 1920 ? 1920 : __width
    // }
  }
}
</script>

<style lang="scss">
  @import "./assets/css/Normalize";
  html,body {
    #app {
      background-color: #F7F8F8;
	  .click{
		  cursor: pointer;
	  }
	  /*  */
	  .flex {
	  	display: flex;
	  }
	  .d-flex {
	  	display: flex;
	  }
	  .d-flex-column {
	  	flex-direction: column;
	  }
	  .d-flex-wrap {
	  	flex-wrap: wrap;
	  }
	  .d-flex-item {
	  	flex: 1;
	  }
	  .d-flex-unShrink {
	  	flex-shrink: 0;
	  }
	  .d-flex-between {
	  	justify-content: space-between;
	  }
	  .d-flex-around {
	  	justify-content: space-around;
	  }
	  .d-flex-center {
	  	justify-content: center;
	  }
	  .d-flex-start {
	  	justify-content: flex-start;
	  }
	  .d-flex-end {
	  	justify-content: flex-end;
	  }
	  .d-flex-middle {
	  	align-items: center;
	  }
	  .d-flex-top {
	  	align-items: flex-start;
	  }
	  .d-flex-bottom {
	  	align-items: flex-end;
	  }
	  .d-flex-align-between {
	  	align-content: space-between;
	  	/* 垂直方向上 */
	  }
	  .d-flex-align-around {
	  	align-content: space-around;
	  }
	  // 
	  .txtOver{overflow: hidden;text-overflow:ellipsis;white-space: nowrap;word-break: break-all;}
	  .txtOver2{overflow : hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;}
	  .txtOver3{overflow : hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;}
	  .txtOver4{overflow : hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;}
    }
  }
</style>
